import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import App from './App.vue';
require('./plugins');
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { registerModules } from './RegisterModules';

import router from './router';
import store from './store';
import axios from './plugins/vue-axios';
import * as interceptor from './plugins/axios_interceptor';
import VueSanitize from 'vue-sanitize';

import { createPinia, PiniaVuePlugin } from 'pinia';

//Modules
import * as Auth from './auth';
import * as Atom from './common';
import * as CheckList from './checkList';
import * as Notification from './notifications';
import * as ModuleSkills from './module';
import * as Gamifications from './gamification';
import * as MyTasks from './myTasks';
import * as onBoard from './onBoard';
import * as dashboard from './dashboard';

const defaultOptions = {
  allowedTags: [
    'a',
    'b',
    'iframe',
    'img',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'p',
    'br',
    'li',
    'ul',
    'ol',
    'span',
  ],
  allowedAttributes: {
    a: ['href'],
    iframe: ['src', 'allow', 'allowfullscreen', 'width', 'height', 'frameborder'],
    img: ['src'],
  },
  selfClosing: ['img', 'br', 'hr', 'input', 'link'],
};
Vue.use(PiniaVuePlugin);
const pinia = createPinia();
Vue.use(VueSanitize, defaultOptions);
Vue.use(BootstrapVue);
Vue.prototype.$errorGlobal = false;

registerModules({
  Auth: Auth,
  Atom: Atom,
  CheckList: CheckList,
  Notification,
  ModuleSkills,
  Gamifications,
  MyTasks,
  onBoard,
  dashboard,
});

new Vue({
  router,
  store,
  axios,
  interceptor,
  pinia,
  render: (h) => h(App),
}).$mount('#app');
